import type {Validation, ValidationFn} from '@/types'

import {Failure, Success, collect} from 'folktale/validation'
import {curry, map, mapObjIndexed, values, isEmpty, contains} from 'ramda'

const _validate = (
  validators: Array<ValidationFn> = [],
  x: any,
): Validation => {
  const results = map(
    (f) => f(x),
    validators,
  )

  return collect(results)
    .map(() => x)
}
export const validate = curry(_validate)

// Takes data with format {name: 'x'}
// and validators with format {name: [isX]}
// returns either Success(data) or Failure([errors])
// after applying all the validators
const _validateObject = (
  validators: {[field: string]: Array<ValidationFn>},
  data: Object,
) => {
  const check = (v, k) => validate(v, data[k])
  const results = mapObjIndexed(check, validators)

  return collect(values(results))
    .map(() => data)
}
export const validateObject = curry(_validateObject)

export const nonEmptyString = (field) => (value) =>
  value && value.trim()
    ? Success(value)
    : Failure([`${field} can't be empty.`])

export const isEmail = (field) => (value) =>
  /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)
    ? Success(value)
    : Failure([`${field} must be an email.`])

export const isMultipleEmail = (field, delimiter) => (value) => {
  if (value) {
    let emails = value.split(',')
    if (isEmpty(emails)) {
      return Failure([`${field} must be an email.`])
    } else {
      let emailsCheck = map((email) =>
        /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email),
      emails)
      return contains(false, emailsCheck)
        ? Failure([`${field} must be an email.`])
        : Success(value)
    }
  }
  return Failure([`${field} must be an email.`])
}

export const isNumber = (field) => (value) =>
  isNaN(value)
    ? Failure([`${field} must be a number.`])
    : Success(value)



// WEBPACK FOOTER //
// ./src/validation.js